module.exports = __webpack_public_path__ + "img/building-modeling.e12a67fb.webp";